export const platformName = window.PLATFORM_NAME || process.env.PLATFORM_NAME;
export const appEnviroment = window.ENVIRONMENT || process.env.ENVIRONMENT;
export const voltBaseUrl = process.env.STORYBOOK_TEST
  ? 'somedomain.testtest'
  : window.VOLT_BASE_URL || (typeof process !== 'undefined' && process.env.VOLT_BASE_URL) || 'https://volt.tento.co';
export const backendBaseUrl = process.env.STORYBOOK_TEST
  ? 'somedomain.testtest'
  : window.BACKEND_BASE_URL || process.env.BACKEND_BASE_URL;
export const auth0Domain =
  window.REACT_APP_AUTH0_DOMAIN ||
  process.env.REACT_APP_AUTH0_DOMAIN ||
  window.AUTH0_DOMAIN ||
  process.env.AUTH0_DOMAIN;
export const googleMapsApi = window.GOOGLE_MAPS_API_KEY || process.env.GOOGLE_MAPS_API_KEY;
export const auth0ClientId =
  window.REACT_APP_AUTH0_CLIENT_ID ||
  process.env.REACT_APP_AUTH0_CLIENT_ID ||
  window.AUTH0_CLIENT_ID ||
  process.env.AUTH0_CLIENT_ID;

export const applyBaseUrl = window.APPLY_BASE_URL || process.env.APPLY_BASE_URL;
export const brandId = window.BRAND_ID || process.env.BRAND_ID;
export const hostname = window.location.hostname;
export const hostnameParts = hostname.split('.');
export const isWoo = hostnameParts.length > 2 && hostnameParts[0] === 'woo';
export const isLocal = hostnameParts.length > 2 && hostnameParts[0] === 'local';
export const contactEmail = backendBaseUrl.includes('tritoncptl')
  ? 'info@tritoncptl.com'
  : isWoo
  ? 'woo@tento.co'
  : 'hello@tento.co';
export const companyName = backendBaseUrl.includes('tritoncptl') ? 'Triton' : 'Tento';

export const isSyntheticTest = window._DATADOG_SYNTHETICS_BROWSER !== undefined;

// Marker the Playwright e2e suite appends to the User-Agent of every browser
// context it opens (see playwright.config.ts in the e2e repo — keep in sync).
export const E2E_USER_AGENT_MARKER = 'TentoE2E';

// Any browser driven by a test rather than a person. Used ONLY to keep
// automated traffic out of Datadog RUM, which the e2e suite otherwise floods:
// it replays whole flows on every run, so /login-test ranked as a top-3 "page"
// and RUM could not be read as a growth-analytics source.
//
// Deliberately kept separate from `isSyntheticTest`, which also gates analytics
// and product behaviour at ~30 call sites — widening that flag would silently
// change what the e2e suite exercises.
export const isAutomatedSession =
  isSyntheticTest || (typeof navigator !== 'undefined' && navigator.userAgent.includes(E2E_USER_AGENT_MARKER));
